import React from 'react';
import { FileText, Download, Printer, Mail, FolderOpen, FileSignature, Lightbulb, Info, RotateCcw, Star, Filter, Search, Calendar, Archive, Trash2, AlertTriangle, SearchCheck, Table, Brain } from 'lucide-react';
import Card from '../../../components/Card/Card';
import SectionHeader from '../../../components/SectionHeader/SectionHeader';
import { FaBrain } from 'react-icons/fa';

function RapportsTab() {
  return (
    <>
      {/* Section: Améliorer votre IA - LE PLUS IMPORTANT */}
      <Card className="card-large">
        <SectionHeader icon={Brain} title="Améliorer votre IA" variant="success" />
        <div className="guide-section-content">
          <div className="guide-warning">
            <Star className="guide-warning-icon" size={20} />
            <p>
              <strong>C'est LE PLUS IMPORTANT</strong> pour améliorer voxia pour vous.
            </p>
          </div>
          <div className="guide-info">
            <Info className="guide-info-icon" size={20} />
            <p>
              Quand vous corrigez un rapport et cliquez sur <strong>"Améliorer"</strong>,
              votre modèle personnel apprend comment <strong>vous</strong> parlez et structurez vos rapports.
              C'est un apprentissage personnalisé rien que pour vous.
            </p>
          </div>
          <div className="guide-steps">
            <div className="guide-step">
              <span className="guide-step-number">1</span>
              <div className="guide-step-content">
                <h4>Corrigez le rapport</h4>
                <p>Modifiez le texte selon vos préférences : formulations, structure, style.</p>
              </div>
            </div>
            <div className="guide-step">
              <span className="guide-step-number">2</span>
              <div className="guide-step-content">
                <h4>Cliquez sur "Améliorer"</h4>
                <p>Votre correction est envoyée pour entraîner votre modèle personnel.</p>
              </div>
            </div>
            <div className="guide-step">
              <span className="guide-step-number">3</span>
              <div className="guide-step-content">
                <h4>L'IA s'améliore pour vous</h4>
                <p>Les prochains rapports seront plus proches de votre style.</p>
              </div>
            </div>
          </div>
          <div className="guide-tip">
            <Lightbulb className="guide-tip-icon" size={20} />
            <p>
              Plus vous corrigez, plus l'IA comprend vos préférences.
              Après quelques corrections, vous verrez une nette amélioration.
            </p>
          </div>
        </div>
      </Card>

      {/* Section: Exporter */}
      <Card className="card-large">
        <SectionHeader icon={Download} title="Exporter un rapport" variant="info" />
        <div className="guide-section-content">
          <div className="guide-features">
            <div className="guide-feature">
              <div className="guide-feature-icon blue">
                <Download size={20} />
              </div>
              <div className="guide-feature-text">
                <h4>Word (.docx)</h4>
                <p>Export au format Microsoft Word</p>
              </div>
            </div>
            <div className="guide-feature">
              <div className="guide-feature-icon gray">
                <Printer size={20} />
              </div>
              <div className="guide-feature-text">
                <h4>Imprimer</h4>
                <p>Impression directe du rapport</p>
              </div>
            </div>
            <div className="guide-feature">
              <div className="guide-feature-icon green">
                <Mail size={20} />
              </div>
              <div className="guide-feature-text">
                <h4>Email</h4>
                <p>Envoi par email (si le modèle mail est choisi)</p>
              </div>
            </div>
          </div>
        </div>
      </Card>

     

      {/* Section: Ordonnances */}
      <Card className="card-large">
        <SectionHeader icon={FileSignature} title="Générer une ordonnance" variant="default" />
        <div className="guide-section-content">
          <div className="guide-info">
            <Info className="guide-info-icon" size={20} />
            <p>
              Pour les rapports de type <strong>consultation</strong> ou <strong>suivi</strong>,
              vous pouvez générer une ordonnance automatiquement.
            </p>
          </div>
          <div className="guide-steps">
            <div className="guide-step">
              <span className="guide-step-number">1</span>
              <div className="guide-step-content">
                <h4>Ouvrez un rapport consultation/suivi</h4>
                <p>Le bouton "Ordonnance" apparaît uniquement pour ces types.</p>
              </div>
            </div>
            <div className="guide-step">
              <span className="guide-step-number">2</span>
              <div className="guide-step-content">
                <h4>Cliquez sur "Ordonnance"</h4>
                <p>L'IA extrait les traitements mentionnés dans le rapport.</p>
              </div>
            </div>
            <div className="guide-step">
              <span className="guide-step-number">3</span>
              <div className="guide-step-content">
                <h4>Vérifiez et exportez</h4>
                <p>Relisez l'ordonnance générée et exportez-la en Word.</p>
              </div>
            </div>
          </div>
        </div>
      </Card>

      {/* Section: Changer de modèle */}
      <Card className="card-large">
        <SectionHeader icon={RotateCcw} title="Changer le modèle de rapport" variant="info" />
        <div className="guide-section-content">
          <div className="guide-info">
            <RotateCcw className="guide-info-icon" size={20} />
            <p>
              Vous vous êtes trompé de modèle ? Cliquez sur <strong>"Changer le modèle"</strong>
              pour régénérer le rapport avec un autre format.
            </p>
          </div>
          <div className="guide-tip">
            <Lightbulb className="guide-tip-icon" size={20} />
            <p>
              Cette fonction utilise la <strong>même dictée originale</strong> mais génère un nouveau
              rapport avec un modèle différent. Les deux versions sont conservées.
            </p>
          </div>
        </div>
      </Card>


      {/* Section: Recherche avancée */}
      <Card className="card-large">
        <SectionHeader icon={SearchCheck} title="Recherche avancée" variant="success" />
        <div className="guide-section-content">
          <span className="guide-badge-gold">Silver / Gold / Enterprise</span>
          <div className="guide-info" style={{ marginTop: '15px' }}>
            <SearchCheck className="guide-info-icon" size={20} />
            <p>
              La recherche avancée permet de trouver des rapports avec des critères précis,
              puis d'<strong>exporter les résultats en Excel</strong>.
            </p>
          </div>
          <div className="guide-features">
            <div className="guide-feature">
              <div className="guide-feature-icon blue">
                <Search size={20} />
              </div>
              <div className="guide-feature-text">
                <h4>Recherche dans le contenu</h4>
                <p>Cherchez des mots ou expressions dans le texte des rapports</p>
              </div>
            </div>
            <div className="guide-feature">
              <div className="guide-feature-icon purple">
                <Filter size={20} />
              </div>
              <div className="guide-feature-text">
                <h4>Termes multiples</h4>
                <p>Combinez plusieurs mots avec ET / OU</p>
              </div>
            </div>
            <div className="guide-feature">
              <div className="guide-feature-icon cyan">
                <Calendar size={20} />
              </div>
              <div className="guide-feature-text">
                <h4>Plage de dates</h4>
                <p>Définissez une date de début et de fin</p>
              </div>
            </div>
          </div>
        </div>
      </Card>

      {/* Section: Export Excel */}
      <Card className="card-large">
        <SectionHeader icon={Table} title="Export Excel" variant="info" />
        <div className="guide-section-content">
          <div className="guide-info">
            <Table className="guide-info-icon" size={20} />
            <p>
              Après une recherche avancée, exportez les résultats en <strong>Excel (.xlsx)</strong> ou <strong>CSV</strong>
              pour analyse dans un tableur.
            </p>
          </div>
          <div className="guide-features">
            <div className="guide-feature">
              <div className="guide-feature-icon green">
                <FileText size={20} />
              </div>
              <div className="guide-feature-text">
                <h4>Choix des colonnes</h4>
                <p>Sélectionnez les sections du rapport à exporter</p>
              </div>
            </div>
            <div className="guide-feature">
              <div className="guide-feature-icon orange">
                <Calendar size={20} />
              </div>
              <div className="guide-feature-text">
                <h4>Date de naissance et âge</h4>
                <p>Extraction automatique depuis le contenu du rapport</p>
              </div>
            </div>
            <div className="guide-feature">
              <div className="guide-feature-icon indigo">
                <Table size={20} />
              </div>
              <div className="guide-feature-text">
                <h4>Extraction de nombres</h4>
                <p>Isolez les valeurs numériques d'une section</p>
              </div>
            </div>
          </div>
          <div className="guide-tip">
            <Lightbulb className="guide-tip-icon" size={20} />
            <p>
              Activez les <strong>statistiques</strong> pour calculer automatiquement
              moyenne, écart-type, médiane et quartiles sur les valeurs numériques.
            </p>
          </div>
        </div>
      </Card>

      {/* Section: Archiver/Supprimer */}
      <Card className="card-large">
        <SectionHeader icon={Archive} title="Archiver ou supprimer" variant="warning" />
        <div className="guide-section-content">
          <div className="guide-features">
            <div className="guide-feature">
              <div className="guide-feature-icon orange">
                <Archive size={20} />
              </div>
              <div className="guide-feature-text">
                <h4>Archiver</h4>
                <p>Masque le rapport de la liste sans le supprimer</p>
              </div>
            </div>
            <div className="guide-feature">
              <div className="guide-feature-icon primary">
                <Trash2 size={20} />
              </div>
              <div className="guide-feature-text">
                <h4>Supprimer</h4>
                <p>Suppression définitive (immédiat et irréversible)</p>
              </div>
            </div>
          </div>
          <div className="guide-warning">
            <AlertTriangle className="guide-warning-icon" size={20} />
            <p>
              La suppression d'un rapport est <strong>définitive</strong>.
              Préférez l'archivage si vous n'êtes pas sûr.
            </p>
          </div>
        </div>
      </Card>

       {/* Section: Stockage local (Electron) */}
       <Card className="card-large">
        <SectionHeader icon={FolderOpen} title="Stockage local (application bureau)" variant="success" />
        <div className="guide-section-content">
          <div className="guide-info">
            <Info className="guide-info-icon" size={20} />
            <p>
              Sur l'application bureau (Windows/Mac), vous pouvez enregistrer vos rapports Word
              <strong> directement dans un dossier local</strong> de votre ordinateur.
            </p>
          </div>
          <div className="guide-steps">
            <div className="guide-step">
              <span className="guide-step-number">1</span>
              <div className="guide-step-content">
                <h4>Ouvrir dans le dossier par défaut</h4>
                <p>Cliquez sur ce bouton pour exporter et ouvrir le fichier Word.</p>
              </div>
            </div>
            <div className="guide-step">
              <span className="guide-step-number">2</span>
              <div className="guide-step-content">
                <h4>Tri par date</h4>
                <p>Dans Réglages, choisissez de trier les fichiers par mois ou par jour.</p>
              </div>
            </div>
          </div>
        </div>
      </Card>
    </>
  );
}

export default RapportsTab;
